import { render, staticRenderFns } from "./AddPermissionsModal.vue?vue&type=template&id=53a2e9e0&scoped=true&"
import script from "./AddPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./AddPermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPermissionsModal.vue?vue&type=style&index=0&id=53a2e9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2e9e0",
  null
  
)

export default component.exports